import React from 'react';
import { DownloadOutlined, DownOutlined, LoadingOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space, Spin } from 'antd';
import styles from '../Style/DatasetInfo.module.scss';

export function BuyButton(props: {
  id: string;
  addedToCart: boolean;
  addToCart: () => void;
  removeFromCart: () => void;
  cartLoading: boolean;
  hasDatasets: boolean;
  disabled: boolean;
  onSwitchToDownload?: () => void;
  showDropdown?: boolean;
}) {
  const menu = (
    <Menu
      onClick={({ key }) => {
        if (key === 'download' && props.onSwitchToDownload) {
          props.onSwitchToDownload();
        }
      }}
    >
      <Menu.Item key="download" icon={<DownloadOutlined />}>
        Download
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {props.addedToCart ? (
        <Button
          type="primary"
          className={styles.CartButton}
          onClick={props.removeFromCart}
          loading={props.cartLoading}
          disabled={!props.hasDatasets}
          style={{ width: '100px' }}
        >
          Remove
        </Button>
      ) : (
        <div style={{ display: 'flex', width: '100%' }}>
          <Button
            id={`PointPanel-AddToCart_Button_${props.id}`}
            type="primary"
            className={styles.CartButton}
            onClick={props.addToCart}
            disabled={!props.hasDatasets || props.disabled}
            style={{ 
              paddingLeft: props.showDropdown ? 1 : 4,
              fontSize: props.showDropdown ? '11px' : '12px',
              width: '100px',
              textAlign: 'left'
            }}
          >
            {props.cartLoading && !props.showDropdown ? 
              <LoadingOutlined spin={props.cartLoading} style={{ marginRight: '5px' }} /> : 
                <ShoppingCartOutlined style={{ fontSize: '12px'}} />}<span style={{marginLeft: props.showDropdown ?'3px' : 5}}> Add to Cart</span>
          </Button>
          
          {props.showDropdown && (
            <Dropdown overlay={menu} trigger={['click']} disabled={props.disabled} placement="bottomRight">
              <Button
                type="primary"
                icon={<DownOutlined />}
                className={styles.CartButton}
                disabled={!props.hasDatasets || props.disabled}
                loading={props.cartLoading}
                style={{ width: '23px', minWidth: '23px', borderLeft: '1px solid lightgray' }}
              />
            </Dropdown>
          )}
        </div>
      )}
    </>
  );
}

export function DownloadButton(props: {
  showCancelDownloadButton: boolean;
  startDownloadProcess: () => void;
  disableDownloadButtons: boolean;
  handleCancelDownload: () => void;
  id: string;
  onSwitchToBuy?: () => void;
  showDropdown?: boolean;
}) {
  const menu = (
    <Menu
      onClick={({ key }) => {
        if (key === 'buy' && props.onSwitchToBuy) {
          props.onSwitchToBuy();
        }
      }}
    >
      <Menu.Item key="buy" icon={<ShoppingCartOutlined />}>
        Add to Cart
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {!props.showCancelDownloadButton ? (
        <div style={{ display: 'flex', width: '100%' }}>
          <Button
            id={`PointPanel-Download_Button_${props.id}`}
            type="primary"
            className={styles.CartButton}
            onClick={() => props.startDownloadProcess()}
            disabled={props.disableDownloadButtons}
            style={{ 
              fontSize: '12px',
              paddingLeft: 2,
              width: '100px',
              textAlign: 'left'
            }}>

            <DownloadOutlined style={{ marginRight: 0 }} /><span style={{marginLeft: '3px'}}>Download</span>

          </Button>
          
          <Dropdown overlay={menu} trigger={['click']} disabled={props.disableDownloadButtons} placement="bottomRight">
            <Button
              type="primary"
              icon={<DownOutlined />}
              className={styles.CartButton}
              disabled={props.disableDownloadButtons}
              style={{ width: '23px', minWidth: '23px', borderLeft: '1px solid lightgray' }}
            />
          </Dropdown>
        </div>
      ) : (
        <Button
          type="primary"
          danger
          icon={<LoadingOutlined />}
          className={styles.CartButton}
          onClick={() => props.handleCancelDownload()}
          style={{ width: '100px' }}
        >
          Cancel
        </Button>
      )}
    </>
  );
}
